namespace st.search.models {
    export class FacetItem implements IFacetItem {
        id: string;
        title: string;
        name: string;
        private _selected: boolean = false;

        constructor(private _parent: FacetItemCollection) {
        }

        get selected() {
            return this._selected;
        }
        set selected(val) {
            if (this._selected !== val) {
                this._selected = val;
                this._parent.notify();
            }
        }
    }

    // Extending an Array in this way is only supported in TypeScript > v2.1
    export class FacetItemCollection extends Array<FacetItem> {
        private _watchers: Function[] = [];
        private _notificationCtx: { notified: boolean } = null;

        indexOfId(id: string): number {
            for (let i = 0; i < this.length; i++) {
                if (id === this[i].id) {
                    return i;
                }
            }
            return -1;
        }

        indexOfName(name: string): number {
            for (let i = 0; i < this.length; i++) {
                if (name === this[i].name) {
                    return i;
                }
            }
            return -1;
        }

        addWatch(watcher: Function): void {
            this._watchers.push(watcher);
        }

        notify(): void {
            if (this._notificationCtx) {
                this._notificationCtx.notified = true;
            } else {
                this._watchers.forEach(fn => {
                    fn();
                });
            }
        }

        /**
         * Suppresses the notificaiton of changed items.
         * @parm The callback.
         * @returns true if a change occured; otherwise false.
         */
        suppressNotify(callback: Function): boolean {
            if (callback) {
                let origCtx = this._notificationCtx;
                this._notificationCtx = { notified: false };
                callback();
                let hasNotified = this._notificationCtx.notified;
                this._notificationCtx = origCtx;
                return hasNotified;
            }
            return false;
        }

        clearSelected(notfy = true): boolean {
            let hasChanged = this.suppressNotify(() => {
                this.forEach(item => {
                    item.selected = false;
                });
            });
            if (hasChanged && notfy) {
                this.notify();
            }
            return hasChanged;
        }

        setSelectedIds(ids: string[], notify = true): boolean {
            let hasChanged = this.setSelected(ids, 'id');

            if (hasChanged && notify) {
                this.notify();
            }
            return hasChanged;
        }

        setSelectedNames(names: string[], notify = true): boolean {
            let hasChanged = this.setSelected(names, 'name');

            if (hasChanged && notify) {
                this.notify();
            }
            return hasChanged;
        }

        private setSelected(items: string[], propName: string): boolean {
            let hasChanged = this.suppressNotify(() => {
                this.forEach(item => {
                    item.selected = items ? items.indexOf(item[propName]) >= 0 : false;
                });
            });
            return hasChanged;
        }

        private findItem(item: { id: string, name: string }): IFacetItem;
        private findItem(index: number): IFacetItem;
        private findItem(x: any): IFacetItem {
            let item: IFacetItem = null;
            let i: number;
            if (typeof x !== 'undefined') {
                if (this.indexOf(x) > -1) {
                    item = x;
                } else if (typeof x === 'number') {
                    item = this[x];
                } else if (x.id && (i = this.indexOfId(x.id)) > -1) {
                    item = this[i];
                } else if (x.name && (i = this.indexOfName(x.name)) > -1) {
                    item = this[i];
                }
            }
            return item;
        }

        toggle(item: IFacetItem, allowMultiple: boolean): void;
        toggle(index: number, allowMultiple: boolean): void;
        toggle(x: any, allowMultiple: boolean): void {
            let item = this.findItem(x);
            if (item) {
                if (item.selected) {
                    item.selected = false;
                } else {
                    if (!allowMultiple) {
                        this.clearSelected(false);
                    }
                    item.selected = true;
                }
            }
        }

        select(item: IFacetItem, allowMultiple: boolean): void;
        select(index: number, allowMultiple: boolean): void;
        select(x: any, allowMultiple: boolean): void {
            let item = this.findItem(x);
            if (item && !item.selected) {
                if (!allowMultiple) {
                    this.clearSelected(false);
                }
                item.selected = true;
            }
        }

        deselect(item: IFacetItem): void;
        deselect(index: number): void;
        deselect(x): void {
            let item = this.findItem(x);
            if (item && item.selected) {
                item.selected = false;
            }
        }
    }
}
